import React, { useContext, useEffect, useState } from 'react';
import { Card } from 'antd';

import RemoteAccessDashboardContext from '@totem/components/services/remoteAccess/v2/summary/remoteAccessDashboardContext';
import { statisticsStyles } from '@totem/components/ui_components/widgets/statistic/IBStatistic';
import { isNotNull } from '@totem/utilities/common';

const IssuesAndInsights = () => {
  const { dashboardData, organizationSummaryData } = useContext(
    RemoteAccessDashboardContext,
  );
  const [issues, setIssues] = useState<string[]>([]);

  useEffect(() => {
    const tmpIssues: string[] = [];

    if (isNotNull(organizationSummaryData)) {
      /* empty */
    }
    if (isNotNull(dashboardData)) {
      if (dashboardData.userSummary.currentNeverUsedCount > 0) {
        tmpIssues.push(`Review and consider disabling Never Used accounts`);
      }
      if (dashboardData.userSummary.currentStaleCount > 0) {
        tmpIssues.push(`Review and consider disabling Stale accounts`);
      }
    }

    setIssues(tmpIssues);
  }, [organizationSummaryData]);

  return (
    <Card
      title={'Issues and Insights'}
      style={{ flex: 1 }}
      styles={{
        header: { ...statisticsStyles.info },
        body: { ...statisticsStyles.subTitle },
        root: { ...statisticsStyles.info },
      }}
    >
      {issues.map((item) => {
        return (
          <div
            key={item}
            style={{ ...statisticsStyles.subTitle, ...statisticsStyles.info }}
          >
            - {item}
          </div>
        );
      })}
    </Card>
  );
};

export default IssuesAndInsights;
